import { render, staticRenderFns } from "./prop1.vue?vue&type=template&id=88c59ada&scoped=true"
import script from "./prop1.vue?vue&type=script&lang=js"
export * from "./prop1.vue?vue&type=script&lang=js"
import style0 from "./prop1.vue?vue&type=style&index=0&id=88c59ada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c59ada",
  null
  
)

export default component.exports